<template>
  <van-tabbar
    route
    fixed
    safe-area-inset-bottom
    active-color="#596afd"
    inactive-color="#8a8f98"
    class="aroma-tabbar"
  >
    <van-tabbar-item :to="tabLocation('AromaReportList')" icon="description">报告</van-tabbar-item>
    <van-tabbar-item :to="tabLocation('AromaShop')" icon="shopping-cart-o">商城</van-tabbar-item>
    <van-tabbar-item :to="tabLocation('AromaMine')" icon="user-o">我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'AromaTabbar',

  computed: {
    sn () {
      return this.$route.query.sn || ''
    }
  },

  methods: {
    tabLocation (name) {
      return { name, query: { sn: this.sn } }
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-tabbar {
  height: 56px;
  border-top: 1px solid #eceef2;
  box-sizing: content-box;

  ::v-deep .van-tabbar-item {
    min-width: 64px;
    min-height: 56px;
    font-size: 12px;
    touch-action: manipulation;
  }

  ::v-deep .van-tabbar-item__icon {
    margin-bottom: 3px;
    font-size: 23px;
  }
}
</style>
